<template>
  <div
    class="name-container text-left"
    :class="{ 'bg-off-white': darkBg }"
  >
    <div
      class="flex items-center justify-between"
      @click="toggleDetails"
    >
      <p class="text-1md text-dark-gray">
        {{ fullName }}
      </p>
      <img
        class="h-8 w-8"
        :class="{ '-rotate-180 transform': details }"
        src="@/assets/arrow-down-black.svg"
        alt="arrow icon"
      />
    </div>
    <div
      v-if="details"
      class="mt-5"
    >
      <div class="flex">
        <p class="mb-4 w-1/4 text-2xs font-bold uppercase text-dark-blue">
          Email
        </p>
        <p class="text-xxs text-body-color">
          {{ email }}
        </p>
      </div>
      <div class="flex">
        <p class="mb-4 w-1/4 text-2xs font-bold uppercase text-dark-blue">
          Last Login
        </p>
        <p class="text-xxs text-body-color">
          {{ lastLogin }}
        </p>
      </div>

      <div class="flex items-center">
        <p class="mb-4 w-1/4 text-2xs font-bold uppercase text-dark-blue">
          Driver
        </p>
        <p class="-mt-4 text-xxs text-body-color">
          <toggle-icon
            :id="user.id"
            small-toggle="true"
            :model-value="getScopes(user, 'driver')"
            scope="driver"
            :scopes="user.scopes"
          />
        </p>
      </div>

      <div class="flex items-center">
        <p class="mb-4 w-1/4 text-2xs font-bold uppercase text-dark-blue">
          Onboarding
        </p>
        <p class="-mt-4 text-xxs text-body-color">
          <toggle-icon
            :id="user.id"
            small-toggle="true"
            :model-value="getScopes(user, 'onboarding')"
            scope="onboarding"
            :scopes="user.scopes"
          />
        </p>
      </div>

      <div class="flex items-center">
        <p class="mb-4 w-1/4 text-2xs font-bold uppercase text-dark-blue">
          View Rate Cons
        </p>
        <p class="-mt-4 text-xxs text-body-color">
          <toggle-icon
            :id="user.id"
            small-toggle="true"
            :model-value="getScopes(user, 'view_rate_confirmations')"
            scope="view_rate_confirmations"
            :scopes="user.scopes"
          />
        </p>
      </div>

      <div class="flex items-center">
        <p class="mb-4 w-1/4 text-2xs font-bold uppercase text-dark-blue">
          Manage Users
        </p>
        <p class="-mt-4 text-xxs text-body-color">
          <toggle-icon
            :id="user.id"
            small-toggle="true"
            :model-value="getScopes(user, 'manage_users')"
            scope="manage_users"
            :scopes="user.scopes"
          />
        </p>
      </div>

      <div class="flex items-center">
        <p class="mb-4 w-1/4 text-2xs font-bold uppercase text-dark-blue">
          View My Loads
        </p>
        <p class="-mt-4 text-xxs text-body-color">
          <toggle-icon
            :id="user.id"
            small-toggle="true"
            :model-value="getScopes(user, 'carrier_load_abilities')"
            scope="carrier_load_abilities"
            :scopes="user.scopes"
          />
        </p>
      </div>

      <div class="flex items-center">
        <p class="mb-4 w-1/4 text-2xs font-bold uppercase text-dark-blue">
          TFX Actions
        </p>
        <p class="-mt-4 text-xxs text-body-color">
          <toggle-icon
            :id="user.id"
            small-toggle="true"
            :model-value="getScopes(user, 'carrier_view_posted_loads')"
            scope="carrier_view_posted_loads"
            :scopes="user.scopes"
          />
        </p>
      </div>

      <!-- <div class="flex">
        <p class="uppercase text-2xs text-dark-blue font-bold w-1/4">
          User Role
        </p>
        <div class="-mt-4 w-full ml-4">
          <dropdown-select
            :light="darkBg"
            :options="this.roles"
            default="Select Role"
            @input="handleDropdown"
            :emitOnMount="false"
            :changePosition="true"
          ></dropdown-select>
        </div>
      </div> -->
      <button
        :disabled="user.id === currentUser.id"
        class="delete-button items-center"
        @click="() => toggleDeleteModalOn(user.id)"
      >
        Delete
        <img
          src="@/assets/trash-icon.svg"
          class="ml-2 inline h-4"
          :class="{ 'disabled-trash-icon': user.id === currentUser.id }"
          alt="trash icon"
          @click="toggleDetails"
        />
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import ToggleIcon from '@/components/ToggleIcon.vue';
// import DropdownSelect from "@/components/DropdownSelect.vue";
export default {
  name: 'Company User Card',
  components: {
    ToggleIcon,
    // DropdownSelect,
  },
  props: {
    user: Object,
    toggleDeleteModalOn: Function,
    darkBg: {
      default: false,
    },
  },
  data() {
    return {
      details: false,
      roles: ['Standard', 'Admin', 'Test'],
    };
  },
  computed: {
    fullName() {
      return this.user.first_name + ' ' + this.user.last_name;
    },
    email() {
      return this.user.email;
    },
    lastLogin() {
      return moment(this.user.last_sign_in_at).format('h:mm A  M/D/YY');
    },
    currentUser() {
      return this.$store.state.users.currentUser;
    },
  },
  methods: {
    getScopes(user, scopeSearched) {
      const sc = (sx) => sx === scopeSearched;
      return user.scopes.some(sc);
    },
    toggleDetails() {
      this.details = !this.details;
    },
    handleDropDown() {
      return null;
    },
  },
};
</script>

<style scoped>
.name-container {
  padding: 12px 14px;
}

.delete-button {
  @apply mt-4 w-full cursor-pointer rounded-md border border-gray-over-dark bg-white text-1md text-gray-over-dark;
  padding: 8.5px 0px !important;
}

.delete-button:disabled {
  @apply border-light-gray bg-white text-light-gray !important;
}

.disabled-trash-icon {
  filter: opacity(0.2);
}
</style>
